import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import './ConfirmationDialog.css';

/**
 * Универсальный диалог подтверждения.
 *
 * Пропсы:
 *  - open          {bool}     — видимость диалога
 *  - title         {string}   — заголовок
 *  - message       {string|node} — текст или JSX с описанием
 *  - confirmText   {string}   — текст кнопки подтверждения (по умолчанию «Подтвердить»)
 *  - cancelText    {string}   — текст кнопки отмены (по умолчанию «Отмена»)
 *  - confirmVariant {'danger'|'success'|'primary'} — стиль кнопки подтверждения
 *  - onConfirm     {fn}       — колбэк при подтверждении
 *  - onCancel      {fn}       — колбэк при отмене/закрытии
 *  - onClose       {fn}       — если не передан, используется onCancel
 *  - disableBackdropClose {bool} — запретить закрытие по клику вне диалога
 */
const ConfirmationDialog = ({
    open,
    title,
    message,
    confirmText = 'Подтвердить',
    cancelText = 'Отмена',
    confirmVariant = 'primary',
    onConfirm,
    onCancel,
    onClose,
    disableBackdropClose = false,
}) => {
    const handleClose = (event, reason) => {
        if (disableBackdropClose && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
        (onClose || onCancel)?.();
    };    
    console.log(open);
    return (
        <Dialog
            open={!!open}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
            classes={{ paper: 'confirm-dialog__paper' }}
        >
            {title && (
                <DialogTitle classes={{ root: 'confirm-dialog__title' }}>
                    {title}
                </DialogTitle>
            )}

            {message && (
                <DialogContent classes={{ root: 'confirm-dialog__content' }}>
                    {typeof message === 'string' ? (
                        <DialogContentText classes={{ root: 'confirm-dialog__text' }}>
                            {message}
                        </DialogContentText>
                    ) : (
                        message
                    )}
                </DialogContent>
            )}

            <DialogActions classes={{ root: 'confirm-dialog__actions' }}>
                <Button
                    onClick={onCancel}
                    className="MuiButton Btn confirm-dialog__btn confirm-dialog__btn_cancel"
                >
                    {cancelText}
                </Button>
                <Button
                    onClick={onConfirm}
                    variant="contained"
                    className={`MuiButton Btn confirm-dialog__btn confirm-dialog__btn_confirm confirm-dialog__btn_${confirmVariant}`}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;